import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

/** Convert the backend's `{error:{status,message,details?}}` envelope (or Pydantic 422) to a plain string. */
export function extractApiError(err, fallback = "Something went wrong.") {
  const data = err?.response?.data;
  if (!data) return err?.message || fallback;
  if (typeof data === "string") return data;
  if (data.error?.message) {
    const details = data.error.details;
    if (Array.isArray(details) && details.length) {
      const pretty = details
        .map((d) => {
          const loc = Array.isArray(d.loc) ? d.loc.slice(-1).join(".") : "";
          return loc ? `${loc}: ${d.msg}` : d.msg;
        })
        .join("; ");
      return `${data.error.message} — ${pretty}`;
    }
    return data.error.message;
  }
  if (data.detail) {
    if (typeof data.detail === "string") return data.detail;
    if (Array.isArray(data.detail))
      return data.detail.map((d) => d.msg || JSON.stringify(d)).join("; ");
  }
  return fallback;
}

/** Try the current session and attempt one silent refresh on 401. */
export async function tryRefresh() {
  try {
    await api.post("/auth/refresh");
    return true;
  } catch {
    return false;
  }
}
